import * as paths from '@workbench-stack/platform/lib/paths';
import * as path from 'path';
import { IEnvironmentService, ParsedArgs, IExtensionHostDebugParams, IDebugParams } from '../interfaces';

export function parseExtensionHostPort(args: ParsedArgs, isBuild: boolean): IExtensionHostDebugParams {
    return parseDebugPort(args.debugPluginHost, args.debugBrkPluginHost, 5870, isBuild, args.debugId);
}

export function parseSearchPort(args: ParsedArgs, isBuild: boolean): IDebugParams {
    return parseDebugPort(args.debugSearch, args.debugBrkSearch, 5876, isBuild);
}

export function parseDebugPort(debugArg: string, debugBrkArg: string, defaultBuildPort: number, isBuild: boolean, debugId?: string): IExtensionHostDebugParams {
    const portStr = debugBrkArg || debugArg;
    const port = Number(portStr) || (!isBuild ? defaultBuildPort : null);
    const brk = port ? Boolean(!!debugBrkArg) : false;
    return { port, break: brk, debugId };
}

export function parsePathArg(arg: string, process: NodeJS.Process): string {
    if (!arg) {
        return undefined;
    }

    // Determine if the arg is relative or absolute, if relative use the original CWD
    // (VSCODE_CWD), not the potentially overridden one (process.cwd()).
    const resolved = path.resolve(arg);

    if (path.normalize(arg) === resolved) {
        return resolved;
    } else {
        return path.resolve(process.env['VSCODE_CWD'] || process.cwd(), arg);
    }
}

export function parseUserDataDir(args: ParsedArgs, process: NodeJS.Process): string {
    return parsePathArg(args['user-data-dir'], process) || path.resolve(paths.getDefaultUserDataPath(process.platform));
}
